import { parseISODate } from "./dateUtils.js";

const fullDateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

const shortDateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

const monthYearFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  year: "numeric",
});

const numberFormatter = new Intl.NumberFormat("en-US");

export function formatDate(dateValue) {
  return fullDateFormatter.format(parseISODate(dateValue));
}

export function formatShortDate(dateValue) {
  return shortDateFormatter.format(parseISODate(dateValue));
}

export function formatMonthYear(dateValue) {
  return monthYearFormatter.format(parseISODate(dateValue));
}

export function formatEpisodeCode(season, episode) {
  return `S${season} E${episode}`;
}

export function formatEpisodeLabel(episode) {
  return `Season ${episode.season} · Episode ${episode.episode}`;
}

export function formatAge(age) {
  return `${age.toFixed(1)} years`;
}

export function formatAgeMarkup(age) {
  const [whole, fraction] = age.toFixed(1).split(".");

  return `
    <span class="age-value" aria-label="${formatAge(age)}">
      <span class="age-whole">${whole}</span><span class="age-decimal">.${fraction}</span>
    </span>
    <span class="age-label">years</span>
  `;
}

export function formatNumber(value) {
  return numberFormatter.format(value);
}
